import { Box, Typography } from "@mui/material";
import { colors } from "../../../ui/colors";
import { signUpIndividualSteps } from "../constants/individual.constants";

export const SideStepNavigation = ({ activeStep }) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: { xs: "row", md: "column" },
      width: { xs: "100%", md: "280px" },
      overflowX: { xs: "auto", md: "visible" },
      pb: { xs: 1, md: 0 },
      mb: { xs: 3, md: 0 },
      "&::-webkit-scrollbar": { display: "none" },
    }}
  >
    {signUpIndividualSteps.map((step, index) => {
      const isActive = activeStep === index;
      return (
        <Box
          key={step.key}
          sx={{
            flex: { xs: "0 0 auto", md: "unset" },
            minWidth: { xs: "200px", sm: "240px", md: "unset" },
            p: { xs: 2, md: 1.5 },
            py: { xs: 1.25, md: 1.25 },
            borderRadius: "10px",
            backgroundColor: isActive ? "white" : colors.gray[50],
            boxShadow: isActive
              ? "0 8px 16px rgba(0,0,0,0.15)"
              : "0 4px 6px rgba(0,0,0,0.08)",
            border: isActive
              ? `2px solid transparent`
              : `1px solid ${colors.gray[200]}`,
            borderImage: isActive
              ? `linear-gradient(135deg, ${colors.yellow[400]}, ${colors.yellow.base}, ${colors.orange[400]}, ${colors.orange.base}) 1`
              : "none",
            transition: "all 0.3s ease",
            transform: isActive
              ? { xs: "scale(1.02)", md: "translateY(-4px) translateX(4px) scale(1.03)" }
              : "none",
            zIndex: isActive ? 2 : 1,
          }}
        >
          <Typography
            sx={{
              fontWeight: isActive ? 800 : 600,
              fontSize: { xs: "16px", sm: "18px", md: "20px" },
              color: isActive ? colors.gray.base : colors.gray[300],
              mb: 0.5,
              whiteSpace: "nowrap",
            }}
          >
            {step.title}
          </Typography>
          <Typography
            sx={{
              fontSize: { xs: "12px", sm: "13px" },
              color: isActive ? colors.gray[400] : colors.gray[300],
              fontWeight: 400,
              whiteSpace: "nowrap",
            }}
          >
            {step.description}
          </Typography>
        </Box>
      );
    })}
  </Box>
);
